import { AccountType } from "@gtmhub/core";
import { AccountResolverService } from "@gtmhub/state/accountResolverService";
import { IComponentOptions, IController } from "angular";

export class FeatureBannerCtrl implements IController {
  isTrialAccount: boolean;
  hideScale: string;
  public static $inject = ["AccountResolverService"];

  constructor(private accountResolverService: AccountResolverService) {}

  $onInit(): void {
    this.isTrialAccount = this.accountResolverService.getAccountData().type === AccountType.TrialAccount;
  }
}

export const FeatureBannerComponent: IComponentOptions = {
  templateUrl: require("../views/feature-banner.jade"),
  controller: FeatureBannerCtrl,
  bindings: {
    hideScale: "<",
  },
};
